import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=0be9e676&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=js&"
export * from "./UserDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=0be9e676&prod&lang=css&"
import style1 from "./UserDetail.vue?vue&type=style&index=1&id=0be9e676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9e676",
  null
  
)

export default component.exports